import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

const Login: React.FC = () => {
  const { user, loading, login } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // 이미 로그인되어 있으면 메인 페이지로 리다이렉트
    if (!loading && user) {
      navigate('/');
    }
  }, [user, loading, navigate]);

  // 에러 메시지 확인
  const queryParams = new URLSearchParams(location.search);
  const error = queryParams.get('error');

  const handleLogin = async () => {
    try {
      await login();
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  if (loading) {
    return (
      <div className="login-container">
        <div className="login-box">
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>SHIFT UP IP Pool Management</h1>
        <p className="login-subtitle">회사 IP 주소 관리 시스템</p>
        
        {error === 'unauthorized_domain' && (
          <div className="error-message">
            SHIFT UP 회사 이메일(@shiftup.co.kr)로만 로그인할 수 있습니다.
          </div>
        )}
        
        <button className="google-login-btn" onClick={handleLogin}>
          <svg className="google-icon" viewBox="0 0 48 48">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
          </svg>
          Google 계정으로 로그인
        </button>
        
        <p className="login-note">
          * SHIFT UP 회사 이메일 계정으로만 로그인 가능합니다
        </p>
      </div>
    </div>
  );
}

export default Login;